import React from 'react'
import { Col, Collapse, Row } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import Container from "../../../../containers/Container";
import DN from '../../../../components/BaoCao/ThongTinChungDetail'
import LicenseResult from '../../../../components/License/LicenseResult'
import TTCdetail from '../../../../components/BaoCao/TTCdetail'
import TTDuAndetail from '../../../../components/BaoCao/TTDuAndetail'
import Api_tnn from "../../../../api/api.tnn";
import Api_quantrac from "../../../../api/api.quantrac";
import Message from "../../../../components/Messages";
import LichSu from '../../../../components/MoiTruong/LichSu/index'

import helper from '../../../../helper/helper'
import typo from '../../../../constants/dictionaries'
import Files from "../../../../components/CongTrinh/FileDinhKem/View"
import HangMucDuAnDetail from '../../../../components/BaoCao/DuAnHangMucDetail/Table';


const { Panel } = Collapse;

class DTMPheDuyetDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      HangMuc: [],
      lichSu: []
    }
  }

  componentDidMount() {
    const { idHoSo } = this.props;
    idHoSo && this.getdtmpheduyetbyId()
  }

  getdtmpheduyetbyId = () => {
    const { idHoSo } = this.props;
    new Api_quantrac().GetBVMT({ token: this.props.user.access_token, id: idHoSo })
      .then(res => {
        this.setState({
          data: res,
          HangMuc: res.duAn.duAn_HangMuc,
          lichSu: res.list_BVMT_LichSu
        })
      })
      .catch(err => {
        Message.error(err.message)
      })
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.idHoSo !== this.props.idHoSo) {
      this.getdtmpheduyetbyId()
    }
  }

  render() {
    const { data, HangMuc, lichSu } = this.state;
    const { files, duAn } = data;
    return (
      <Container>
        <Row type="flex">
          <Col span={12}>
            <Collapse bordered={false} defaultActiveKey={['1']}>
              <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_license_organization, 1)}</a>} key="1">
                <DN data={data} />
              </Panel>
            </Collapse>
          </Col>
          <Col span={11} offset={1}>
            <Collapse bordered={false} defaultActiveKey={['1']}>
              <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_lichsu, 2)}</a>} key="1">
                <LichSu dataSource={lichSu} />
              </Panel>
            </Collapse>

            <Collapse bordered={false} defaultActiveKey={['1']}>
              <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_fileTaiLieu, 2)}</a>} key="1">
                <Files dataSource={files || []} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
        <Row type="flex">
          <Col span={12}>
            <Collapse bordered={false} defaultActiveKey={['1']}>
              <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_title_detail_ttc, 3)}</a>} key="1">
                <TTCdetail data={data} />
              </Panel>
            </Collapse>

          </Col>
          <Col span={11} offset={1}>
            <Collapse bordered={false} defaultActiveKey={['1']}>
              <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_title_detail, 4)}</a>} key="1">
                <TTDuAndetail data={duAn} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Collapse bordered={false} defaultActiveKey={['1']}>
            <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_title_detail_hm, 5)}</a>} key="1">
              <HangMucDuAnDetail dataSource={HangMuc} />
            </Panel>
          </Collapse>


        </Row>
      </Container>
    )
  }
}

DTMPheDuyetDetail.propTypes = {
  idHoSo: PropTypes.string
};


const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(DTMPheDuyetDetail)